/**
 * The tools whose result carries a media marker for the chat to embed — the
 * records with `emitsMedia` (`tests/tool-records.test.ts` holds the two equal).
 * A separate list because the chat imports it: deriving it from the catalog
 * would put every tool record into the app bundle (~37 KB gzipped).
 */
export const MEDIA_TOOL_NAMES: ReadonlySet<string> = new Set([
  'show_media',
  'browser_screenshot',
  'web_screenshot',
  'desktop_screenshot',
  'desktop_record',
]);
